module.exports = __webpack_public_path__ + "img/guidedTours.5809c9f8.png";